import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initErrorReporting } from './utils/error-reporting';
import { initThemeBridge } from './config/theme';

import '@client/config/copy/i18n';

initErrorReporting();
// Before render so an embed opened from a dark Dashboard never flashes light.
initThemeBridge();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
